module.exports = __webpack_public_path__ + "static/media/1.7ca9929d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/special/1.png
// module id = 1547
// module chunks = 0